import '@/components/common/css/course/reserve.css';
import '@/components/common/css/studentCard/studentCardList.less';
import Back from '@/components/public/back/Back.vue';
import {mapState} from 'vuex';
import api from '../../common/libs/api.js';
import {responseResultValidate} from '@/common/libs/common.js';
import CityCodeData from '@/common/libs/CityCodeData';

export default {
  name: 'studentCardList',
  components: {
    Back
  },
  data() {
    return {
            
    }
  },
  computed: mapState({
    cardList: state => state.studentCardList.cardList
  }),
  watch: {
    cardList: {
      handler: function() {

      },
      deep: true
    }
  },
  methods: {
    //切换学员卡
    changeStudentCard(studentObj){
      if (studentObj.selected == 1){ //已选择
        this.$store.dispatch('toast', {title: '当前学员已选择', show: true});
      } else {
        api.apiMethod.switchStudentCard.post({studentId: studentObj.studentId}, {
          headers: {
            'Content-Type': 'application/json'
					}
        }).then(res => {
          if (responseResultValidate(res.data, {name: 'studentCardList'})){  //返回结果通过校验
            if (res.data.errcode == 0){
              this.$store.dispatch('toast', {title: '学员切换成功', show: true});
              //this.$store.dispatch('getCardList');
              let cityName = this.$route.params.city;
              if (studentObj.cityCode && studentObj.cityCode.length != 0) {
                let city = CityCodeData.getCityByCode(studentObj.cityCode);
                cityName = city.first_word;
              }
              this.$router.push({
                name: 'mine',
                params: {
                  city: cityName
                } 
              });
            } else {
              this.$store.dispatch('toast', {title: res.data.msg, show: true});
            }
          }
        });
      }
    }
  },
  mounted() {
    //获取学员卡list
    this.$store.dispatch('getCardList');
    /**不显示页头页尾 */
    this.$store.commit('isShowHeader', {isShowHeader: false});
    this.$store.commit('isShowFooter', {isShowFooter: false});
  }
}


// WEBPACK FOOTER //
// ./src/components/studentCard/studentCardList.js